import CustomIcon from "@/components/ui/custom-icon";
import Image from "next/image";
import { CollectionListResourceCollections } from "@/api/generated-api";
import { FC } from "react";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import Link from "next/link";

interface ICollectionSectionCard {
  collection: CollectionListResourceCollections;
}

const CollectionSectionCard: FC<ICollectionSectionCard> = ({ collection }) => {
  const t = useTranslations();
  const { id, title, image, subtitle } = collection;

  return (
    <Link className={S.collectionItem} href={`/collections/${id}`}>
      <Image src={image as string} width={448} height={662} alt="Collection" />
      <div className={S.collectionContent}>
        <p className={S.collectionTitle}>{title}</p>
        <p className={S.collectionDesc}>{subtitle}</p>
        <p className={S.collectionText}>
          {t("readMore")} <CustomIcon fileName="icon-arrow-right" />
        </p>
      </div>
    </Link>
  );
};

export default CollectionSectionCard;
